module.exports = __webpack_public_path__ + "img/07_map.3234204a.webp";